import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'

class GetDefaultConsentsUserUseCase extends UseCase {
  #repository

  constructor({repository}) {
    super()
    this.#repository = repository
  }

  static create({config}) {
    return new GetDefaultConsentsUserUseCase({
      repository: UserRepositoriesFactory.httpUserRepository({config})
    })
  }

  @tracer({metric: 'GetDefaultConsentsUserUseCase#execute'})
  @AsyncInlineError()
  async execute() {
    const [error, consents] = await this.#repository.getDefaultConsents()

    if (error) return Promise.reject(error)

    return consents
  }
}

export const factory = GetDefaultConsentsUserUseCase.create
